"use client";

import { useEffect } from "react";
import { Container } from "@/src/components/container";
import { Swiper } from "swiper/react";
import "swiper/swiper-bundle.min.css";

import SwiperCore, { Autoplay } from "swiper";
import { useDomReady } from "@/src/hooks/dom-ready";
import { ServiceCard } from "@/src/components/cards/service/v4";
import { ServiceSectionProps } from "..";

SwiperCore.use([Autoplay]);

// Scroll function with offset
const scrollToElementWithOffset = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    const yOffset = -80;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export function ServiceCardsCaraousl({
  cards,
}: Pick<ServiceSectionProps, "cards">) {
  const isDomReady = useDomReady();

  const hash = isDomReady && window.location.hash;

  const groupedCards = [];
  for (let i = 0; i < cards.length; i += 3) {
    groupedCards.push(cards.slice(i, i + 3));
  }

  // Wait until DOM is ready and cards are rendered
  useEffect(() => {
    if (isDomReady && cards.length > 0) {
      const hash = window.location.hash;
      if (hash) {
        const id = hash.replace("#", "");
        // Wait a bit to make sure DOM is rendered
        setTimeout(() => scrollToElementWithOffset(id), 100);
      }
    }
  }, [isDomReady, cards.length, hash]);

  return (
    <>
      {isDomReady && (
        <Container>
          {groupedCards && groupedCards.length > 0 && (
            <div className="mt-[90px]">
              <Swiper
                className="!overflow-visible"
                speed={400}
                loop
                spaceBetween={30}
                slidesPerView={3}
                slidesPerGroup={3}
                breakpoints={{
                  0: { spaceBetween: 30, slidesPerView: 1 },
                  375: { spaceBetween: 30, slidesPerView: 1 },
                  575: { spaceBetween: 30, slidesPerView: 1 },
                  768: { spaceBetween: 30, slidesPerView: 2 },
                  992: { spaceBetween: 30, slidesPerView: 2 },
                  1200: { spaceBetween: 30, slidesPerView: 3 },
                }}
              >
{groupedCards.map((group, i) => {
  let globalIndex = i === 0 ? 0 : groupedCards.slice(0, i).flat().length;

  return (
    <div
      key={i}
      className="grid grid-cols-1 gap-6 p-2 md:grid-cols-3 lg:grid-cols-3"
    >
      {group.map((card, index) => {
        const flatIndex = globalIndex + index;
        console.log("card?.href?.split('=')[0]", flatIndex);

        return (
          <div key={flatIndex} id={flatIndex}>
            <ServiceCard {...card} />
          </div>
        );
      })}
    </div>
  );
})}

              </Swiper>
            </div>
          )}
        </Container>
      )}
    </>
  );
}
